import type { MouseEvent } from 'react'
import { dispatchSubsNavigation } from '@/msgdeskRuntime/subsNavigation'

// Modern refresh button — self-contained (markup + wiring + Tailwind).
// Same behaviour as ../Legacy; re-skinned via the scoped md-refresh-subs--modern
// class (clean icon chip instead of the sprite).

export function RefreshSubs({ section }: { section: 0 | 1 }) {
  function handleRefresh(event: MouseEvent<HTMLElement>) {
    dispatchSubsNavigation({ action: 'refresh', section, target: event.currentTarget })
  }

  return (
    <span
      className="md-hook-no-select md-refresh-subs md-refresh-subs--modern inline-flex h-6 w-6 flex-[0_0_24px] cursor-pointer select-none items-center justify-center rounded-[7px] bg-slate-100 text-slate-600 transition-colors duration-150 hover:bg-slate-200 hover:text-[#2563eb]"
      data-md-legacy-class="mcss-no_select-cssm"
      title="Refresh"
      onClick={handleRefresh}
    >
      <span aria-hidden="true" className="text-[15px] leading-none">↻</span>
    </span>
  )
}
